import { talks } from "../../../mocks/homeData";

const avatars = ["bg-primary-100 text-primary-700", "bg-accent-100 text-accent-900", "bg-secondary-100 text-secondary-900", "bg-primary-50 text-primary-500"];

export default function Talk() {
  return (
    <section id="talk" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <span className="text-xs font-bold tracking-widest text-primary-600">COMMUNITY TALK</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">热议圈 · 前排占座</h2>
          </div>
          <span className="hidden items-center gap-1.5 text-sm text-foreground-500 sm:inline-flex">
            <i className="ri-group-fill text-accent-600"></i> 2.4w 网友正在围观
          </span>
        </div>

        {/* 静态评论输入示意 */}
        <div className="mt-8 flex items-center gap-3 rounded-2xl border border-background-200 bg-background-50 p-3 md:p-4">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
            <i className="ri-user-3-fill text-lg"></i>
          </span>
          <div className="flex-1 rounded-full bg-background-100 px-4 py-2.5 text-sm text-foreground-400">
            来聊两句，把你的看法摆上桌…
          </div>
          <a
            href="#follow"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-700 transition-colors cursor-pointer"
          >
            发一条
          </a>
        </div>

        {/* 热议列表 */}
        <div className="mt-5 space-y-4">
          {talks.map((t, i) => (
            <article
              key={t.handle}
              className="rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-heading text-sm font-black ${avatars[i % avatars.length]}`}
                >
                  {t.handle.slice(0, 1)}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <p className="text-sm font-bold text-foreground-950 whitespace-nowrap">{t.handle}</p>
                    {t.pinned && (
                      <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-bold text-accent-900">
                        <i className="ri-pushpin-2-fill"></i> 置顶热评
                      </span>
                    )}
                    <span className="text-xs text-foreground-400">{t.time}</span>
                  </div>
                  <span className="mt-0.5 inline-flex items-center gap-1 text-[11px] font-semibold text-primary-600">
                    <i className="ri-price-tag-3-line"></i> {t.tag}
                  </span>
                </div>
              </div>

              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">{t.text}</p>

              <div className="mt-3 flex flex-wrap items-center gap-4 border-t border-background-100 pt-3 text-xs text-foreground-500">
                <button type="button" className="inline-flex items-center gap-1.5 hover:text-primary-600 cursor-pointer">
                  <i className="ri-thumb-up-line text-base"></i> 顶 {t.agree}
                </button>
                <button type="button" className="inline-flex items-center gap-1.5 hover:text-primary-600 cursor-pointer">
                  <i className="ri-chat-3-line text-base"></i> 回复 {t.replies}
                </button>
                <button type="button" className="inline-flex items-center gap-1.5 hover:text-primary-600 cursor-pointer">
                  <i className="ri-bookmark-line text-base"></i> 收藏
                </button>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-400">
          讨论氛围靠大家维护：理性吃瓜、引用截图请说明来源，避免误伤。
        </p>
      </div>
    </section>
  );
}